import React from 'react';

interface FilterBarProps {
  /** Filter inputs — typically <FilterBar.Item> children. */
  children: React.ReactNode;
  /** Right-aligned action buttons (Export CSV, Recompute, Lock Day, etc.). */
  actions?: React.ReactNode;
  className?: string;
}

interface FilterItemProps {
  label?: React.ReactNode;
  htmlFor?: string;
  children: React.ReactNode;
  className?: string;
}

function FilterItem({ label, htmlFor, children, className }: FilterItemProps) {
  const wrapperClass = ['filter-item', className].filter(Boolean).join(' ');
  return (
    <div className={wrapperClass}>
      {label && <label htmlFor={htmlFor}>{label}</label>}
      {children}
    </div>
  );
}

function FilterBar({ children, actions, className }: FilterBarProps) {
  const wrapperClass = [
    'logistics-controls-container',
    actions ? 'logistics-controls-container--has-actions' : null,
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <div className={wrapperClass}>
      <div className="filters-group">{children}</div>
      {actions && <div className="filters-actions">{actions}</div>}
    </div>
  );
}

FilterBar.Item = FilterItem;

export default FilterBar;
